import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SystemDtoKeysEnum } from '@zaoblako/shared/modules/system/enums/system-dto-keys.enum';
import { semVerSchema } from '@zaoblako/shared/modules/serde/schemas/sem-ver.schema';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

import * as yup from 'yup';

/** Changelog message create and update APIs request body - DTO signature */
export interface ChangelogFormInterface {
  /** Application full version in SemVer format. Unique identifier of the changelog. */
  version: string;
  /** Publication datetime */
  publicationDate: Date;
  /** Changelog message content */
  description: string;
  /** Short summary of changelog */
  shortSummary: string;
}

/** Changelog message create and update APIs request body - DTO schema */
export const ChangelogFormDto = SerdeDtoClass.create<ChangelogFormInterface>(SystemDtoKeysEnum.CHANGELOG_FORM_DTO, {
  version: {
    label: 'Версия',
    serializer: semVerSchema,
  },
  publicationDate: {
    sortable: true,
    label: 'Дата публикации',
    serializer: yup.date(),
  },
  description: {
    label: 'Текст сообщения',
    serializer: nonEmptyStringSchema,
  },
  shortSummary: {
    optional: true,
    label: 'Краткое описание',
    serializer: yup.string(),
  },
});
